export enum TransportationType {
  ByFoot = 'by_foot',
  ByBicycle = 'by_bike',
  ByCar = 'by_car',
  ByPublicTransport = 'by_public_transport',
}

export const TRANSPORTATION_TYPE_I18N: Record<TransportationType, string> = {
  [TransportationType.ByBicycle]: 'Mit dem Fahrrad',
  [TransportationType.ByCar]: 'Mit dem Auto',
  [TransportationType.ByFoot]: 'Zu Fuß',
  [TransportationType.ByPublicTransport]: 'Mit den öffentlichen Verkehrsmitteln',
};
